<template>
  <div id="header" style="height: 229px;">
    <div class="wh1200">
      <div class="header_top">
        <div v-for="(item,index) in logos" :key="index">
          <a  v-if="index==0" :href="item.herf" target="_blank" class="wai_logo01"><img src="../static/wai_logo01.png" alt=""></a>
          <a  v-if="index==1" :href="item.herf" target="_blank"  class="wai_logo02"><img src="../static/wai_logo02.png" alt=""></a>
          <a  v-if="index==2" :href="item.herf" target="_blank" class="logo logo_banner"><img src="../static/logo.png" alt=""></a>
        </div>

        <div class="h_top_right">
          <div class="register_sign">
            <a href="javascript:;" @click="sign()">登录</a>
            <a href="javascript:;" @click="reset()">注册</a>
          </div>
          <div class="register_sign02" style="display: none;">欢迎！用户名文字<a href="javascript:;">注销</a></div>
          <div  class="header_form">
            <input v-model="text" type="text" placeholder="请输入搜索关键词">
            <button @click="search"></button>
          </div>
        </div>
      </div>
      <div class="navigation">
        <ul>
          <li @click="index" :class="selectIndex ==1?'active':''"><a><img src="../static/nav_icon01.png" alt="">首页</a></li>
          <li @click="news" :class="selectIndex ==2?'active':''"><a><img src="../static/nav_icon02.png" alt="">新闻中心</a></li>
          <li :class="selectIndex ==3?'active':''" class="hover_set" @mousemove="res=>{show= true}">
            <a @mouseout="res=>{show= false}"><img src="../static/nav_icon03.png" alt="">产业资讯</a>
            <div @mouseout="res=>{show= false}" class="headset_nav" v-show="show">
              <a @click="getTypeClick('')">全部</a>
              <a v-for="item in typeList" :key="item" @click="getTypeClick(item.types_id)">{{item.name}}</a>
            </div>
          </li>
          <li @click="data" :class="selectIndex ==4?'active':''"><a><img src="../static/nav_icon04.png" alt="">产业数据库</a></li>
          <li @click="linbo" :class="selectIndex ==5?'active':''"><a><img src="../static/nav_icon05.png" alt="">网上林博会</a></li>
          <li @click="publics" :class="selectIndex ==6?'active':''"><a><img src="../static/nav_icon06.png" alt="">通知公示</a></li>
          <div class="clear"></div>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import informationlist from '@/api/modules/informationlist'
export default {
  data () {
    return {
      show: false,
      typeList: [],
      text: '',
      selectIndex: 1,
      logos: null
    }
  },
  created () {
    this.gettype()
    this.logo()
    if (sessionStorage.getItem('selectIndex')) {
      this.selectIndex = sessionStorage.getItem('selectIndex')
   
    }
  },
  methods: {

    logo () {
      axios({
        method: 'post',
        url: informationlist.logo,
        data: {
          level: '30'
        }
      }).then(res => {
        this.logos = JSON.parse(res.data.list[0].values)
        // console.log(JSON.parse(res.data.list[0].values))
      })
    },

    gettype () {
      axios({
        method: 'post',
        url: informationlist.typelist,
        data: {}
      }).then(res => {
        this.typeList = res.data.list
      })
    },
    getTypeClick (id) {
      this.$router.push({
        path: '/informationlist',
        query: {
          'id': id
        }
      })
      this.show = false
      this.selectIndex = 3
      sessionStorage.setItem('selectIndex', 3)
    },
    sign () {
      this.$router.push({
        path: '/sign_in'
      })
    },
    reset () {
      this.$router.push({
        path: '/register'
      })
    },
    news () {
      this.$router.push({
        path: '/newslist'
      })
      this.selectIndex = 2
      sessionStorage.setItem('selectIndex', 2)
    },
    index () {
      this.$router.push({
        path: '/'
      })
      this.selectIndex = 1
      sessionStorage.setItem('selectIndex', 1)
    },
    information () {
      this.$router.push({
        path: '/informationlist'
      })
    },
    data () {
      this.$router.push({
        path: '/datalist'
      })
      this.selectIndex = 4
      sessionStorage.setItem('selectIndex', 4)
    },
    linbo () {
      this.$router.push({
        path: '/linbolist'
      })
      this.selectIndex = 5
      sessionStorage.setItem('selectIndex', 5)
    },
    publics () {
      this.$router.push({
        path: '/publiclist'
      })
      this.selectIndex = 6
      sessionStorage.setItem('selectIndex', 6)
    },
    search () {
      if (!this.text) {
        alert('搜索关键字不能为空')
      } else {
        this.$router.push({ path: '/search', query: {'searchtext': this.text} })
      }
    }
  }
}

</script>

<style scoped>
  #header{
    height: auto!important;
  }
  .wh1200 {
    max-width: 1200px;
    margin: 0 auto;
  }

  .header_top {
    overflow: hidden;
    padding: 30px 0px 20px;
  }

  .header_top a {
    float: left;
  }
  .header_top a.logo{
    width: 300px;
    margin-left: 167px;
    margin-top: -11px;
  }
  .header_top a img {
    width: 100%;
    display: block;
  }

  .header_top .h_top_right {
    float: right;
  }

  .wai_logo02 {
    display: block;
    width: 120px;
  }

  .wai_logo01 {
    display: block;
    width: 120px;
    margin-right: 10px;
  }

  .register_sign {
    overflow: hidden;
  }

  .register_sign a {
    float: right;
    font-size: 16px;
    color: #333333;
    margin-left: 20px;
    -webkit-transition: all 0.2s ease-out;
    -khtml-transition: all 0.2s ease-out;
    -moz-transition: all 0.2s ease-out;
    -o-transition: all 0.2s ease-out;
    transition: all 0.2s ease-out;
  }

  .register_sign a:hover {
    color: #cc0001;
  }
  .header_form {
    overflow: hidden;
    margin-top: 44px;
  }
  .header_form input {
    width: 240px;
    box-sizing: border-box;
    height: 40px;
    border: 1px solid #dddddd;
    padding: 0px 15px;
    border-radius: 3px 0px 0px 3px;
    color: #111;
    float: left;
  }

  .header_form button {
    width: 60px;
    height: 40px;
    background: #cc0001 url(../static/search.png) center center no-repeat;
    float: left;
    border: none;
    border-radius: 0px 3px 3px 0px;
    cursor: pointer;
    -webkit-transition: all 0.2s ease-out;
    -khtml-transition: all 0.2s ease-out;
    -moz-transition: all 0.2s ease-out;
    -o-transition: all 0.2s ease-out;
    transition: all 0.2s ease-out;
  }

  .header_form button:hover {
    background: rgba(204, 0, 1, 0.8) url(../static/search.png) center center no-repeat;
  }

  .navigation.active ul {
    position: fixed;
  }

  .navigation {
    height: 50px;
    position: relative;
  }

  .navigation ul {
    width: 1200px;
    /* position: absolute; */
    left: 50%;
    margin-left: -600px;
    top: 0px;
    background: #cc0001;
    height: 50px;
    line-height: 50px;
    -webkit-transition: all 0.2s ease-out;
    -khtml-transition: all 0.2s ease-out;
    -moz-transition: all 0.2s ease-out;
    -o-transition: all 0.2s ease-out;
    transition: all 0.2s ease-out;
    padding: 0px;
    margin: 0px;
  }

  .navigation ul li {
    float: left;
    width: 16.66666667%;
    position: relative;
    list-style: none
  }

  .navigation ul li .headset_nav {
    position: absolute;
    width: 300px;
    overflow: hidden;
    background: #f32c2d;
    top: 100%;
    left: 0px;
    padding: 20px 0px;
    animation: myfirst 0.3s;
  }
  /* 下拉过度效果 */
  @keyframes myfirst {
    0%{
      opacity: 0;
    }
    100%{
      opacity: 1;
    }
  }
  .navigation ul li .headset_nav a {
    float: left;
    width: 50%;
    font-size: 16px;
    color: #fff;
    height: 40px;
    line-height: 40px;
    -webkit-transition: all 0.2s ease-out;
    -khtml-transition: all 0.2s ease-out;
    -moz-transition: all 0.2s ease-out;
    -o-transition: all 0.2s ease-out;
    transition: all 0.2s ease-out;
    text-decoration: none;
  }

  .navigation ul li .headset_nav a:hover {
    color: #ffda2d;
  }

  .navigation ul li a {
    display: block;
    text-align: center;
    font-size: 18px;
    color: #fff;
    -webkit-transition: all 0.2s ease-out;
    -khtml-transition: all 0.2s ease-out;
    -moz-transition: all 0.2s ease-out;
    -o-transition: all 0.2s ease-out;
    transition: all 0.2s ease-out;
    text-decoration: none;
    cursor: pointer;
  }

  .navigation ul li a img {
    vertical-align: top;
    display: inline-block;
    position: relative;
    top: 17px;
    margin-right: 10px;
    width: 23px;
  }

  .navigation ul li a:hover {
    background: #f32c2d;
  }

  .navigation ul li.active a {
    background: #f32c2d;
  }

  .navigation ul li.hover_set a:after {
    content: '';
    display: inline-block;
    width: 10px;
    height: 7px;
    background: url(../static/nav_down_icon.png) center center no-repeat;
    background-size: cover !important;
    margin-left: 15px;
  }

  .navigation ul li.hover_set .headset_nav a:after {
    display: none;
  }

  .register_sign02 {
    text-align: right;
    font-size: 16px;
    color: #111;
  }

  .register_sign02 a {
    color: #cc0001;
    display: inline-block;
    margin-left: 20px;
    float: none;
  }

  .headset_nav {
    z-index: 9999;
  }
.logo_banner{
 height:111px;
  }
  .logo_banner img{
 height:100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/headers.vue